import { useEffect, useState } from "react";

export const useDynamicImage = (fileName?: string) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<unknown>(null);
  const [image, setImage] = useState<string>();

  useEffect(() => {
    if (!fileName) return;

    const fetchImage = async () => {
      try {
        const [name, extension] = fileName.split(".");
        const response = await import(
          `../images/showcase/${name}.${extension}?url`
        );
        setImage(response.default);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchImage();
  }, [fileName]);

  return {
    loading,
    error,
    image,
  };
};
